import { render, staticRenderFns } from "./ProfileAvatarButton.vue?vue&type=template&id=7bf88bdf&scoped=true&"
import script from "./ProfileAvatarButton.vue?vue&type=script&lang=js&"
export * from "./ProfileAvatarButton.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAvatarButton.vue?vue&type=style&index=0&id=7bf88bdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf88bdf",
  null
  
)

export default component.exports